import {history} from '../../../history'
import {store} from '../../utilities'
import {setPopup} from '../../action_creators'



export default function onRow(record, setListFilters) {
  return {
    style: {cursor: `pointer`},
    onClick: (e) => {
      if (e.metaKey) return window.open(`/projects/${record.id}/manage`)
      const state = store.getState()
      //console.log("state",state)
      //console.log('state.tableControls.pagination > ',state.tableControls.pagination)
      if (setListFilters) {
        setListFilters((prevFilters) => ({
          ...prevFilters,
          type: "projects", 
          query : { 
            status : state?.query?.status || null,
            fullTextQuery: state?.query?.fullTextQuery || null,
            filters: state?.query?.filters || null,
            from: state?.query?.from || 0
          }, // Resetting the filter
          tableControls: {
            sorter: state?.tableControls?.sorter || null,
            pagination: state?.tableControls?.pagination || null
          }
        }))
      }
      history.push(`/projects/${record.id}/manage`)
    },
    onContextMenu: (e) => {
      e.preventDefault()
      const state = store.getState()

      if (!state.tableVars.popup.x) store.dispatch(setPopup(record, e.clientX, e.clientY))
    },
  }
}
